import { render, staticRenderFns } from "./CompanyPreferencesSetting.vue?vue&type=template&id=07afe933&scoped=true"
import script from "./CompanyPreferencesSetting.vue?vue&type=script&lang=js"
export * from "./CompanyPreferencesSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyPreferencesSetting.vue?vue&type=style&index=0&id=07afe933&lang=scss&scoped=true"
import style1 from "./CompanyPreferencesSetting.vue?vue&type=style&index=1&id=07afe933&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07afe933",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07afe933')) {
      api.createRecord('07afe933', component.options)
    } else {
      api.reload('07afe933', component.options)
    }
    module.hot.accept("./CompanyPreferencesSetting.vue?vue&type=template&id=07afe933&scoped=true", function () {
      api.rerender('07afe933', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyPreferencesSetting.vue"
export default component.exports